const loginInvite = function() {
  const loginInvitationElement = document.querySelector(".js-invite-to-login");
  const loginButton = document.querySelector(".js-login-button");
  if (loginInvitationElement && loginButton) {
    loginButton.click();
  }
};

export default loginInvite;
